import { UserListComponent } from '@components/module/user/list/user-list.component';
import UnauthorizedPage from '@pages/404.page';
import { Role } from '@shared/constants';
import { getAuthData } from '@store/entities/auth';
import { useSelector } from 'react-redux';

const UserListPage = () => {
  const { auth } = useSelector(getAuthData);
  const role = auth?.UserRole[0]?.name;
  let renderPage = <UnauthorizedPage />;

  if (auth) {
    switch (role) {
      case Role?.USER_SUPER_ADMIN:
        renderPage = <UserListComponent auth={auth} />
        break;
      default:
        break;
    }
  }
  return <>{renderPage}</>
}

export default UserListPage;
